
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/produs/[slug]",
      function () {
        return require("private-next-pages/produs/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/produs/[slug]"])
      });
    }
  